import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "VideoAdd"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.5 11.25H10.5V8.25H9V11.25H6V12.75H9V15.75H10.5V12.75H13.5V11.25ZM3 19.5H15.75C16.5781 19.4992 17.2492 18.8281 17.25 18V14.958L21.3143 17.8605C21.5429 18.0237 21.8436 18.0455 22.0933 17.9169C22.3431 17.7883 22.5 17.5309 22.5 17.25V6.75C22.4997 6.46922 22.3427 6.2121 22.093 6.0837C21.8433 5.95529 21.5428 5.97712 21.3143 6.14025L17.25 9.04275V6C17.2492 5.17192 16.5781 4.50083 15.75 4.5H3C2.17192 4.50083 1.50083 5.17192 1.5 6V18C1.50083 18.8281 2.17192 19.4992 3 19.5ZM3 18.0007V6H15.75V10.5C15.75 10.7809 15.9069 11.0383 16.1567 11.1669C16.4064 11.2955 16.7071 11.2737 16.9357 11.1105L21 8.208V15.792L16.9357 12.8895C16.7071 12.7263 16.4064 12.7045 16.1567 12.8331C15.9069 12.9617 15.75 13.2191 15.75 13.5V18L3 18.0007Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/VideoAdd.vue"]]);
